import "./chatting.css";
import TimeAgo from "timeago-react";
import { Link } from "react-router-dom";
import { serverInfo } from "../../../App";
import { useContext } from "react";
// import { format } from "timeago.js";

export default function Message({ message, color, userInfo }) {

  const { imageCdnUrl } = useContext(serverInfo);

  return (
    <>
      <div
        className={message.sender_id == userInfo.id ? "message own" : "message"}
      >
        <div
          className={
            message.sender_id == userInfo.id
              ? "text-muted message-sender"
              : "text-muted message-receiver"
          }
        >
          <Link className="text-light" to={`/profile/${message.sender_id}`}>
            {message.sender_name}{" "}
          </Link>
        </div>
        <div className="messageTop">
          <div className="d-flex flex-column justify-content-center">
            <img
              className="messageImg"
              src={imageCdnUrl + message.sender_image}
              alt=""
            />
          </div>

          <p className="messageText">{message.text}</p>
        </div>
        <div className="messageBottom text-muted">
          <TimeAgo datetime={message.created_at} locale="vi" />
        </div>
      </div>
    </>
  );
}
